import { save, load } from './storage';
import type { Vacancy, VacancyListResponse } from '@/services/vacancy.service';

const VACANCIES_KEY = 'vacancies';

export const localVacancyService = {
  async list(): Promise<VacancyListResponse> {
    const vacancies = load<Vacancy[]>(VACANCIES_KEY, []);
    return {
      vacancies,
      pagination: {
        total: vacancies.length,
        limit: vacancies.length,
        offset: 0,
      },
    };
  },

  async add(vacancy: Vacancy): Promise<Vacancy> {
    const vacancies = load<Vacancy[]>(VACANCIES_KEY, []);
    const updated = [...vacancies, vacancy];
    save(VACANCIES_KEY, updated);
    return vacancy;
  },

  async remove(id: string): Promise<void> {
    const vacancies = load<Vacancy[]>(VACANCIES_KEY, []);
    save(
      VACANCIES_KEY,
      vacancies.filter((v) => v.id !== id)
    );
  },
};












